import * as React from 'react';

import * as UI from 'core/ui';

import * as Images from 'pos/Images';

import { Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { Command } from 'pos/common';
import { Res, Permission, ProductAvailabilityDTO } from 'core/api';
import { ActionButtonDefinition, PosScreenClassComponent, ScreenSize } from 'pos/ui';
import { CatalogueFacade } from 'pos/facades';
import { Cols, Col, Flex } from 'core/ui';
import { Message, Modal } from 'core/ui-next/modal';


const format = UI.Format.asDecimalWith(3);

type Props = {
	products: ProductAvailabilityDTO[]
} & Modal.Actions<ProductAvailabilityDTO[]>;

type State = {
	filterText: string;
};

class ShowProductAvailability extends PosScreenClassComponent<Props, State> {

	protected getScreenId(): string {
		return 'GET_PRODUCT_AVAILABILITY';
	}

	protected getTitle(): string {
		return Res.Web.GET_PRODUCT_AVAILABILITY();
	}

	protected getImage(): string | SvgIcon {
		return Images.ProductAvailability;
	}

	protected getSize(): ScreenSize {
		return 'medium';
	}

	protected getActionButtonsDefs(): Nullable<ActionButtonDefinition>[] {
		return [
			this.cancelButton(),
			null,
			null,
			null,
			null,
			null
		];
	}

	protected useKeypad(): boolean {
		return false;
	}

	createInitialState(_props: Props): Nullable<State> {
		return { filterText: '' };
	}

	onComponentDidMount(): void {
	}

	onComponentWillUnmount(): void {
	}

	protected getContent(): React.ReactNode {

		let inputSearch = React.createRef<HTMLInputElement>();

		const { Button } = UI;

		const onFilter = () => {
			const filterText = inputSearch.current!.value;
			this.setState({ filterText });
		};

		const clearFilter = () => {
			inputSearch.current!.value = '';
			this.setState({ filterText: '' });
		};

		const quantities = this.props.products
			.filter(p => this.state.filterText === '' || p.Name.toLocaleLowerCase().includes(this.state.filterText.toLocaleLowerCase()))
			.map(x => (<li key={x.Id}>
				<Cols className='text-18'>
					<Col width='*' className='text-left m-t-xs'>{x.Name}</Col>
					<Col width='22ex' className='text-right'>
						{format(x.CurrentQuantity)}
					</Col>
				</Cols>
			</li>));

		return <Flex.Horizontal>
			<Flex.Item size='*' className='border-right'>
				<Flex.Vertical>
					<Flex.Item>
						<div className='input-group m-sm'>
							<input id='search' ref={inputSearch} type='text' className='form-control' placeholder={Res.WA.WA_SEARCH_PLACE_HOLDER()} onKeyUp={UI.debounce(onFilter)} />
							<span className='input-group-btn'>
								<Button onClick={clearFilter}><i className='text-info fa fa-remove'></i></Button>
							</span>
						</div>
					</Flex.Item>
					<Flex.Item>
						<Cols className='list-header'>
							<Col width='*' className='text-left'>
								{Res.Web.PRODUCT_AVAILABILITY_LIST_CONTROL_PRODUCT_LBL()}
							</Col>
							<Col width='*' className='text-right'>
								{Res.Web.PRODUCT_AVAILABILITY_LIST_CONTROL_QUANTITY_LBL()}
							</Col>
						</Cols>
					</Flex.Item>
					<Flex.Item size='*'>
						<ul className='list'>
							{quantities}
						</ul>
					</Flex.Item>
				</Flex.Vertical>
			</Flex.Item>
		</Flex.Horizontal>;
	}
}

declare global {
	interface CommandType {
		getProductAvailability: () => Promise<Result>
	}
}

Command.register('getProductAvailability', Preconditions.ensure(Permission.ProductAvailability_Get), async (): Promise<Result> => {

	const availableQuantities = (await CatalogueFacade.getProductAvailableQuantities()).filter(x => x.CurrentQuantity !== null);
	if (availableQuantities.length === 0) {
		await Message.show(Res.Msg.MSG_ALL_PRODUCTS_HAS_AVAILABILITY());
		return Result.ok();
	}

	await Modal.show(ShowProductAvailability, { products: availableQuantities });
	return Result.ok();
});
